module.exports = __webpack_public_path__ + "img/yjk04.f3a2d776.png";